import React, { Suspense } from 'react'

import { HistoryList } from './parts/HistoryList'
import { ListSkeleton } from '@/components/ListSkeleton'
import ErrorPage from '@/pages/Error'
import { ErrorBoundary } from '@/components/ErrorBoundary'

const HistoryTab: React.FC = () => {
  return (
    <ErrorBoundary fallback={<ErrorPage />}>
      <Suspense
        fallback={
          <ListSkeleton.Wrapper count={3}>
            <ListSkeleton.HistoryItem />
          </ListSkeleton.Wrapper>
        }
      >
        <HistoryList />
      </Suspense>
    </ErrorBoundary>
  )
}

export default HistoryTab
